const postMessageService = {
    isPostMessageSupported() {
        return typeof window.parent?.postMessage === 'function';
    },

    postTo(recipient, messageBody) {
        if (postMessageService.isPostMessageSupported()) {
            return recipient?.postMessage(messageBody, '*');
        }
        return false;
    },
};

export default postMessageService;
